import React from 'react';

export const RedirectPage = ({ url }: { url: string }) => {
	React.useEffect(() => {
		window.location.replace(url);
	}, []);

	return <div> Redirecting to {url} </div>;
};
